import { Box } from '@mui/material';
import { DRAWER_WIDTH } from './layout/layoutHeader';
import { JSX } from 'react';
import { LoadingButton } from '@mui/lab';
import Content from '../../common/components/content';

interface StepFooterProps {
  /**
   * Callback for back button click
   * If not provided, back button will not be rendered
   */
  onClickBack?: () => void;
  /**
   * Callback for next button click
   */
  onClickNext: () => void;
  /**
   * Flag indicating if loading is in progress and buttons should be disabled
   */
  isLoading: boolean;
  /**
   * Title for next button
   * @default 'Next'
   */
  nextButtonTitle?: string;
}

/**
 * Floating footer panel with back and next buttons
 */
const StepFooter = ({
  onClickBack,
  onClickNext,
  isLoading,
  nextButtonTitle = 'Next',
}: StepFooterProps): JSX.Element => (
  <Box
    className="bg-white fixed bottom-0 z-10 left-0 right-0 py-4 border-t-2 shadow-lg"
    sx={{ left: { sm: `${DRAWER_WIDTH}px` } }}
  >
    <Content>
      <Box className="flex justify-between space-x-4">
        {onClickBack ? (
          <LoadingButton disabled={isLoading} onClick={onClickBack} variant="outlined">
            Back
          </LoadingButton>
        ) : (
          <Box />
        )}
        <LoadingButton
          loading={isLoading}
          onClick={onClickNext}
          variant="contained"
          color="secondary"
        >
          {nextButtonTitle}
        </LoadingButton>
      </Box>
    </Content>
  </Box>
);
export default StepFooter;
